import React, { useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate, useParams } from "react-router-dom";

const JoinRoom = () => {
  const { roomId } = useParams();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleJoin = async () => {
    const roomRef = doc(db, "rooms", roomId);
    const roomSnap = await getDoc(roomRef);

    if (!roomSnap.exists()) {
      setError("Room does not exist");
      navigate("/create");
      return;
    }

    if (roomSnap.data().password !== password) {
      setError("Wrong password");
      return;
    }

    localStorage.setItem("username", name);
    navigate(`/room/${roomId}/chat`);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Join Room: {roomId}</h2>

      <input
        placeholder="Your Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <input
        placeholder="Room Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button onClick={handleJoin}>Join</button>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};
export default JoinRoom;
